import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["frame","close"]

  openFrame(event) {
    event.preventDefault()

    // Get the frame ID from data-frame-target attribute
    const frameId = this.element.dataset.frameTarget
    if (!frameId) {
      console.error("No frame target specified in data-frame-target")
      return
    }

    // Find the target frame
    const frame = document.getElementById(frameId)
    if (!frame) {
      console.error(`Frame with ID ${frameId} not found`)
      return
    }

    // Hide the back button
    this.hideBackButton()

    // Show spinner in the frame
    frame.innerHTML = this.getSpinnerHTML()

    // Get optional URL modifications from data attributes
    let url = this.element.href
    const urlParams = this.element.dataset.urlParams
    if (urlParams) {
      try {
      const params = JSON.parse(urlParams)
      const urlObj = new URL(url, document.baseURI)
      Object.entries(params).forEach(([key, value]) => {
        urlObj.searchParams.set(key, value)
      })
      url = urlObj.toString()
      } catch (error) {
        console.error("Invalid JSON in data-url-params:", urlParams, error)
      }
    }

    // Trigger Turbo visit to the href, targeting the specified frame
    Turbo.visit(url, { frame: frameId })
  }

  hideBackButton() {
    const backButton = document.getElementById("product-back-button")
    if (backButton) backButton.style.display = "none"
  }

  getSpinnerHTML() {
    return `
      <div class="d-flex justify-content-center align-items-center" style="height:70vh;">
        <div class="circle-spinner-border"></div>
      </div>
    `
  }

  handleClickOutside = (event) => {
    const openModals = Array.from(document.querySelectorAll(".modal.show"))
    if (openModals.length === 0) return

    // Special handling for form controls - if it's a button or input, don't close the modal
    const formTags = ['INPUT', 'BUTTON', 'SELECT', 'TEXTAREA', 'LABEL', 'LI'];
    if (formTags.includes(event.target.tagName) ||
        event.target.closest('input, button, select, textarea, label, .custom-control')) {
      return;
    }

    // Check if the click target is inside any modal content
    const clickedInsideModal = openModals.some((modal) => {
      const modalDialog = modal.querySelector(".modal-dialog")
      const modalContent = modal.querySelector(".modal-content")

      return (modalDialog?.contains(event.target) || modalContent?.contains(event.target))
    })

    const clickedBackdrop = event.target.classList.contains("modal-backdrop")
    const isDropzoneInput = event.target.classList.contains("dz-hidden-input")
    const isCloseButton = event.target.classList.contains("fa-times")

    if (clickedBackdrop || !clickedInsideModal) {
      openModals.forEach((modal) => {
        if(!isDropzoneInput && !isCloseButton){
          $(modal).modal("hide")
        }
      })
    }
  }

  hide() {
    const modalId = this.element.dataset.modalId
    $(`#${modalId}`).modal('hide')
  }
}
